// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_aa0ee33f","title":"_d120d4ec","description":"_4022b98a"};